import { apiFetch } from './apiFetch';
import type { SalaryComponents } from '@salaries/shared';

export async function getBoxSalaryDefaults(): Promise<SalaryComponents> {
  return apiFetch<SalaryComponents>('/salary-defaults');
}

export async function updateBoxSalaryDefaults(
  components: SalaryComponents,
): Promise<SalaryComponents> {
  return apiFetch<SalaryComponents>('/salary-defaults', {
    method: 'PUT',
    body: JSON.stringify(components),
  });
}
